import { api } from './client';
import type { MKDObject, Construct, Paginated } from '@/types';

export const objectsApi = {
  async list(filters: { city?: string; search?: string; status?: string } = {}): Promise<Paginated<MKDObject>> {
    const { data } = await api.get<Paginated<MKDObject>>('/objects/', { params: filters });
    return data;
  },
  async get(id: number): Promise<MKDObject> {
    const { data } = await api.get<MKDObject>(`/objects/${id}/`);
    return data;
  },
  async create(payload: Partial<MKDObject>): Promise<MKDObject> {
    const { data } = await api.post<MKDObject>('/objects/', payload);
    return data;
  },
  async constructs(id: number): Promise<Construct[]> {
    const { data } = await api.get<Construct[]>(`/objects/${id}/constructs/`);
    return data;
  },
};
